import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiPlus, FiMinus } = FiIcons;

function FAQAccordion({ items }) {
  const [active, setActive] = useState(0);

  return (
    <div className="faq-list">
      {items.map((item, index) => {
        const open = active === index;
        return (
          <article className={`faq-item ${open ? 'open' : ''}`} key={item.question}>
            <button onClick={() => setActive(open ? -1 : index)} aria-expanded={open}>
              <span>{item.question}</span>
              <SafeIcon icon={open ? FiMinus : FiPlus} />
            </button>
            <div className="faq-answer"><p>{item.answer}</p></div>
          </article>
        );
      })}
    </div>
  );
}

export default FAQAccordion;